import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const API_URL = "https://accessoriesgirly.onrender.com/api/categories";

export default function CategorySection() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchCategories = async () => {
      setLoading(true);
      try {
        const res = await axios.get(API_URL);
        setCategories(res.data);
      } catch (err) {
        console.error("Error fetching categories:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchCategories();
  }, []);

  return (
    <section className="py-16 bg-pink-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl font-extrabold text-pink-700 mb-12">
          Shop by Categories
        </h2>

        {loading ? (
          <p className="text-gray-600 text-lg">Loading categories...</p>
        ) : categories.length > 0 ? (
          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-8">
            {categories.map((category) => (
              <Link
                key={category._id}
                to={`/categories/${category._id}`}
                className="group relative bg-white border border-pink-200 shadow-lg rounded-2xl overflow-hidden transform transition-all duration-300 hover:scale-105 hover:shadow-2xl"
              >
                {/* Full image container */}
                <div className="w-full h-48 overflow-hidden rounded-t-2xl">
                  <img
                    src={category.image || "https://via.placeholder.com/300x200"}
                    alt={category.name}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                </div>

                {/* Text overlay */}
                <div className="p-6 flex flex-col items-center justify-center">
                  <span className="text-xl font-semibold text-gray-800 group-hover:text-pink-600">
                    {category.name}
                  </span>
                </div>

                {/* Decorative gradient circle in corner */}
                <div className="absolute -top-4 -right-4 w-16 h-16 rounded-full bg-gradient-to-tr from-pink-400 to-pink-600 opacity-30 pointer-events-none"></div>
              </Link>
            ))}
          </div>
        ) : (
          <p className="text-gray-500 text-lg">No categories found.</p>
        )}
      </div>
    </section>
  );
}
